import React from 'react'
import { getDisplayName } from 'util/hoc'
import { connect } from 'react-redux'
import {
  doUpdateReplyDraftRecipientsFromUrl,
  doUpdateDraftFieldsFromUrl,
} from 'ducks/drafts'

const perform = {
  doUpdateReplyDraftRecipientsFromUrl,
  doUpdateDraftFieldsFromUrl,
}

export function withQueryParamsHandling(WrappedPage) {
  class WithQueryParamsHandling extends React.Component {
    componentDidMount() {
      this.props.doUpdateReplyDraftRecipientsFromUrl()
      this.props.doUpdateDraftFieldsFromUrl()
    }

    render() {
      return <WrappedPage {...this.props} />
    }
  }

  WithQueryParamsHandling.displayName = `WithQueryParamsHandling(${getDisplayName(
    WrappedPage
  )})`

  return connect(null, perform)(WithQueryParamsHandling)
}
